import { Injectable } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { ICONLIST, iconMap } from '../core/models/Icons';
import { faChartBar } from '@fortawesome/free-regular-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor() {}

  listIcons() {
    return ICONLIST;
  }

  getIcon(iconName): IconDefinition {
    switch (iconName) {
      case 'chart-bar':
        return faChartBar;
      default:
        return iconMap[iconName] ?? faGear;
    }
  }
}
